import React, { FunctionComponent } from 'react'

import { Person } from '../../../App/store/features/person/IPerson'
import { TOpenEventDetails } from '../../types'
import { CreateAppointment } from '../Appointment/CreateAppointment'
import { UpdateAppointment } from '../Appointment/UpdateAppointment'
import { BlockForm } from '../BlockForm'
import { UpdateBlock } from '../BlockForm/UpdateBlock'
import { FormError } from '../FormError'
import { LastMinutesForm } from '../LastMinutesForm'

interface IProps {
  personList: Person[]
  eventDetails: TOpenEventDetails
  setIsPanelFocus: (state: boolean) => void
}

export const FormSwitch: FunctionComponent<IProps> = ({
  personList,
  eventDetails,
  setIsPanelFocus,
}) => {
  switch (eventDetails.type) {
    case 'create_appointment':
      return (
        <CreateAppointment
          appointmentDetails={eventDetails.event}
          personList={personList}
          setIsPanelFocus={setIsPanelFocus}
        />
      )
    case 'create_lastMinutes':
      return (
        <LastMinutesForm
          selectedPersonUuid={eventDetails.event.selectedPerson.personUuid}
          appointmentMoment={eventDetails.event.startsAt}
        />
      )
    case 'create_block':
      return (
        <BlockForm
          selectedPersonUuid={eventDetails.event.selectedPerson.personUuid}
          persons={personList}
          appointmentMoment={eventDetails.event.startsAt}
        />
      )
    case 'update_appointment_details':
    case 'update_appointment_print':
    case 'update_appointment_notes':
    case 'update_appointment_delete':
      return (
        <UpdateAppointment
          appointmentDetails={eventDetails.event}
          openEventDetails={eventDetails}
          personList={personList}
        />
      )
    case 'update_block':
      return (
        <UpdateBlock
          blockDetails={eventDetails.event}
          personList={personList}
        />
      )
    default:
      return <FormError />
  }
}
